import React, { useMemo } from "react";
import {
  AlertTriangle,
  Card,
  ClipboardList,
  Clock3,
  Circle,
  Store,
} from "../../../ui";
import { tx } from "../../ludConnect.constants";
import { elapsedInfo, statusInfo } from "../../helpers/ludConnect.helpers";
import "./PortalStats.css";
import { GitBranch } from "lucide-react";

const PortalStats = ({ ar, restCounter, branchesCounter, requests, isProvider }) => {
  const cards = useMemo(() => {
    const visible = requests.filter(
      (request) =>
        !request.deleted &&
        (isProvider ? request.status !== "draft" : true),
    );
    const open = visible.filter(
      (request) => !statusInfo(request.status, ar).final,
    );
    const overdue = open.filter(
      (request) => elapsedInfo(request, ar).className === "late",
    );

    return [
      {
        Icon: ClipboardList,
        num: visible.length,
        label: tx("إجمالي الطلبات", "Total requests", ar),
      },
      {
        Icon: Circle,
        num: open.length,
        label: tx("طلبات مفتوحة", "Open requests", ar),
      },
      {
        Icon: AlertTriangle,
        num: overdue.length,
        label: tx("متأخرة (+24 ساعة)", "Overdue (+24 hours)", ar),
        kind: "danger",
      },
      {
        Icon: Clock3,
        num: visible.filter(
          (request) =>
            new Date(request.createdAt).toDateString() ===
            new Date().toDateString(),
        ).length,
        label: tx("طلبات اليوم", "Today's requests", ar),
      },
      {
        Icon: Store,
        num: restCounter,
        label: tx("المتاجر", "Stores", ar),
        kind: "good",
      },
      {
        Icon: GitBranch,
        num: branchesCounter,
        label: tx("الفروع", "Branches", ar),
        kind: "good",
      },
    ];
  }, [ar, requests, isProvider, restCounter, branchesCounter]);

  return (
    <div className="lud-connect__stats">
      {cards.map(({ Icon, ...card }, index) => (
        <Card
          key={`${card.label}-${index}`}
          className={`lud-connect__stat ${card.kind || ""}`}
          hoverable={false}
        >
          <Icon size={18} />
          <strong>{card.num}</strong>
          <small>{card.label}</small>
        </Card>
      ))}
    </div>
  );
};

export default PortalStats;
